<div [formGroup]="form">
  <mat-form-field appearance="outline" [ngClass]="{'no-error-padding': noErrorPadding}">
    <mat-label>{{ 'BANNER_AUTOCOMPLETE.PLACEHOLDER' | translate }}</mat-label>
    <input matInput [formControlName]="controlName" [matAutocomplete]="auto"/>
    <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption [displayWith]="getDisplayText"
                      (optionSelected)="emitSelection($event)">
      <mat-option *ngFor="let option of search$ | async; let index = index"
                  [value]="option">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <img width="38px" [src]="getLogoUrl(option)" *ngIf="getLogoUrl(option)" alt="Banner Logo"/>
          <span>{{ option.name }}</span>
        </div>
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="form.get(controlName).hasError('required')">
      <i>{{ 'BANNER_AUTOCOMPLETE.ERRORS.REQUIRED' | translate }}</i>
    </mat-error>
    <mat-error *ngIf="form.get(controlName).hasError('requiresMatch')">
      <i>{{ 'BANNER_AUTOCOMPLETE.ERRORS.REQUIRES_MATCH' | translate }}</i>
    </mat-error>
  </mat-form-field>
</div>
